import React from 'react';
import {View, Text, Linking} from 'react-native';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import {styles} from '../UpdateModal/styles';

const WEB_URL = 'https://conectabrasal.com.br';

// Apenas o conteúdo. O <Modal> é fornecido pelo AppModalHost
// para evitar concorrência de apresentação no iOS.
const BuildProblemModal = () => {
  return (
    <View style={styles.containerModal}>
      <View style={styles.containerFilter}>
        <Text
          style={{
            fontSize: 20,
            lineHeight: 26,
            color: 'black',
            textAlign: 'center',
            maxWidth: 300,
            alignSelf: 'center',
            fontFamily: 'TCCC-UnityText Bold',
            marginTop: 20,
          }}>
          Estamos resolvendo um problema
        </Text>

        <View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 30,
            }}>
            Identificamos um problema
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            nesta versão do aplicativo.
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 280,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            Por favor, utilize a versão web
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 280,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            enquanto corrigimos.
          </Text>
        </View>

        <View style={styles.containerButton}>
          <ButtonComponent
            title="Acessar versão web"
            outlined
            width="80%"
            onPress={() => Linking.openURL(WEB_URL)}
          />
        </View>
      </View>
    </View>
  );
};

export default BuildProblemModal;
